import { render } from "./PostbackEditor.vue?vue&type=template&id=4f355cb6&scoped=true"
import script from "./PostbackEditor.vue?vue&type=script&lang=js"
export * from "./PostbackEditor.vue?vue&type=script&lang=js"

import "./PostbackEditor.vue?vue&type=style&index=0&id=4f355cb6&scoped=true&lang=css"
import "./PostbackEditor.vue?vue&type=style&index=1&id=4f355cb6&lang=css"

import exportComponent from "/codebuild/output/src2135/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f355cb6"]])

export default __exports__